import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import TicketCreation from './TicketCreation/TicketCreationContainer';
import TicketsPage from './Tickets/TicketsPage';
import TicketDetails from './Details';
import LearningCenter from './LearningCenter/LearningCenterContainer';
import VideoContainer from './LearningCenter/Video/VideoContainer';
import PortalGuideContainer from './LearningCenter/PortalGuide/PortalGuideContainer';
import FAQ from './FAQ';
import FAQSearchResult from './FAQSearchResult';
import FAQCategories from './FAQCategories';
import { JSX } from 'react';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import ProtectedRoute from '@/utils/ProtectedRoute';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('support');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewSupportTickets}
        showPermission
        exact
        path="/tickets"
        component={TicketsPage}
      />

      {/* TODO: remove once we've fully removed the old submit ticket page */}
      <ProtectedRoute
        isAllowed={!!lockedFeatures.SupportTicketEnabled && featureFlags.isEnabled && featureFlags.CreateSupportTickets}
        showPermission
        exact
        path="/create-tickets"
        component={TicketCreation}
      />

      {/* TODO: remove once we've fully removed the old submit ticket page */}
      <ProtectedRoute
        isAllowed={!!lockedFeatures.SupportTicketEnabled && featureFlags.isEnabled && featureFlags.CreateSupportTickets}
        showPermission
        exact
        path="/tickets/create"
        component={TicketCreation}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/tickets/:id"
        component={TicketDetails}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/learning-centre"
        component={LearningCenter}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/learning-centre/video-tutorials"
        component={VideoContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/learning-centre/pdf-guide"
        component={PortalGuideContainer}
      />
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission exact path="/faq" component={FAQ} />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        path="/category/:categoryName"
        component={FAQCategories}
      />
      {/* <ProtectedRoute path="/category/vopay-portal">
      <FAQCategories categoryName="VoPay Portal" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/vopay-api">
      <FAQCategories categoryName="VoPay API" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/payment-processing">
      <FAQCategories categoryName="Payment Processing" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/payment-rails">
      <FAQCategories categoryName="Payment Rails" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/security">
      <FAQCategories categoryName="Security" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/payment-troubleshooting">
      <FAQCategories categoryName="Payment Troubleshooting" />
    </ProtectedRoute>
    <ProtectedRoute path="/category/customer-support">
      <FAQCategories categoryName="Customer Support" />
    </ProtectedRoute> */}
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        path="/faq-search-result"
        component={FAQSearchResult}
      />
    </Switch>
  );
};

export default Routes;
